import { FC } from "react";
import wb500Icon from "./icons/wb500.png";
import { IPopupProps, Popup } from "../Popup";
import { ChannelLink } from "../../Links/ChannelLink/ChannelLink";
import { ThinButton } from "../../Buttons/ThinButton/ThinButton";
import { getChannelLink } from "../../../utils/platform-links";
import { getPlatformText } from "../../../utils/platform-text";

export const FirstDrawPopup: FC<IPopupProps> = ({ onClose }) => {
    const getDescription = () => {
        const channel = getChannelLink();
        return (
            <>
                <p>
                    <span>Не забудьте подписаться на </span>
                    <ChannelLink caption={`наш ${getPlatformText("channelName")}`} />
                </p>
                <p>
                    Именно там мы называем победителей, а как Вы сможете забрать подарок, если даже не узнаете, что выиграли его? 🤔
                </p>
                <ThinButton
                    caption='Подписаться'
                    handler={() => {
                        if (!channel) return;
                        window.location.href = channel;
                    }}
                />
            </>
        );
    }

    return (
        <Popup
            title="Вы участвуете в розыгрыше"
            description={ getDescription() }
            icon={ wb500Icon }
            onClose={ onClose }
        />
    );
};
